import React, { useState, useEffect, useRef, useCallback } from "react";
import DataGrid, {
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Selection,
  Scrolling,
  LoadPanel,
  SearchPanel,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnChooserSelection,
  Position,
  MasterDetail,
  Format,
  Pager,
  Paging,
  Button,
} from "devextreme-react/data-grid";
import DateBox from "devextreme-react/date-box";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import "whatwg-fetch";
import { useStyles } from "../../Styles.js";
import { createStore } from "devextreme-aspnet-data-nojquery";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Button1 from "@material-ui/core/Button";
import { api_path } from "../../shared.js";
import CostSheetMasterDetailView from "./CostSheetMasterDetailView";
import Select from "react-select";
import axios from "axios";
import TextField from "@material-ui/core/TextField";
import { MultiSelect } from "react-multi-select-component";
import useDeviceSize from "../../hooks/useDeviceSize";
import Modal from "react-bootstrap/Modal";
import Guid from "devextreme/core/guid";
import swal from "sweetalert";
import dateFormat from "dateformat";
export function CostSheetDataGrid(props) {
  const userId = JSON.parse(localStorage.getItem("USER_ID"));
  const token = process.env.REACT_APP_API_TOKEN;
  const [width, height] = useDeviceSize();
  const [loadPanelEnabled, setLoadPanelEnabled] = useState(true);
  const onContentReady = useCallback(() => {
    setLoadPanelEnabled(false);
  }, []);
  const [getLoadGrid, setLoadGrid] = useState();
  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  const [commentData, setCommentData] = useState([]);
  const classes = useStyles();
  const now = new Date();
  const dateLabel = { "aria-label": "Date" };
  const [GET_COST_ID, SET_COST_ID] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showComment, setShowComment] = useState(false);
  const handleCloseComment = () => setShowComment(false);
  const handleShowComment = () => setShowComment(true);
  const [REMARK, SET_REMARK] = useState("");
  const [GET_DEL, SET_DEL] = useState("");
  const [origin, setOrigin] = useState(null);
  const [originList, setOriginList] = useState([]);
  const [selectOrigin, setSelectOrigin] = useState([]);
  const [pod, setPod] = useState([]);
  const [podList, setPodList] = useState([]);
  const [selectPod, setSelectPod] = useState([]);
  const [delivery, setDelivery] = useState(null);
  const [deliveryList, setDeliveryList] = useState([]);
  const [selectDelivery, setSelectDelivery] = useState([]);
  const [getType, setType] = useState([]);
  const [typeList, setTypeList] = useState([]);
  const [selectType, setSelectType] = useState([]);
  const [getServiceType, setServiceType] = useState([]);
  const [ServiceTypeList, setServiceTypeList] = useState([]);
  const [selectServiceType, setSelectServiceType] = useState([]);
  const [getTotalCount, setTotalCount] = useState();
  const [getDateStr, setDateStr] = useState(
    "Please click Search button to refresh data."
  );
  const [getSearchStatus, setSearchStatus] = useState(0);
  var date = new Date();
  var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  const formattedfirstDay = firstDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");

  const formattedlastDay = lastDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");

  const [getDateFrom, setDateFrom] = useState(formattedfirstDay);
  const [getDateTo, setDateTo] = useState(formattedlastDay);
  const [getMinDate, setMinDate] = useState(null);
  const ref = useRef();
  const pageSizes = [25, 50, 100, 200];
  function formatDate(value) {
    let date = new Date(value);
    const day = date.toLocaleString("default", { day: "2-digit" });
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.toLocaleString("default", { year: "numeric" });
    return day + "-" + month + "-" + year;
  }

  const handleSearch = (e) => {
    setSearchStatus(1);
    setDateStr(
      " [ Effective date from " +
        formatDate(getDateFrom) +
        " To " +
        formatDate(getDateTo) +
        " ]"
    );
  };
  const handleClearInputClick = () => {
    setDateStr("Please click Search button to refresh data.");
    setSearchStatus(0);
    setOrigin([]);
    //setPod([]);
    setDelivery([]);
    setType([]);
    setServiceType([]);
    setDateFrom(formattedfirstDay);
    setDateTo(formattedlastDay);
    setSelectOrigin([]);
    //setSelectPod([]);
    setSelectDelivery([]);
    setSelectType([]);
    setSelectServiceType([]);
    setDateStr("");
    setTotalCount(0);
  };
  useEffect(() => {
    //if(props.USER_COUNTRY=="TH"){

    // }else{
    // setSelectOrigin("MALAYSIA");
    // setOrigin({
    //   ORIGIN: "MALAYSIA",
    //   ORIGIN: "MALAYSIA",
    // });
    // }
    fetchType();
    fetchServiceType();
  }, []);
  const onValueChangedDateFrom = React.useCallback((e) => {
    setDateStr("Please click Search button to refresh data.");
    setSearchStatus(0);
    const dateFrom = new Date(e.value);
    const formattedDateFrom = dateFrom
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateFrom(formattedDateFrom);
    setMinDate(formattedDateFrom);
    setOrigin(null);
    setDelivery(null);
  }, []);
  const onValueChangedDateTo = React.useCallback((e) => {
    setDateStr("Please click Search button to refresh data.");
    setSearchStatus(0);
    const dateTo = new Date(e.value);
    const formattedDateTo = dateTo
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateTo(formattedDateTo);
  }, []);
  useEffect(() => {
    // if(props.USER_COUNTRY=="TH"){
    const getOriginDropdown = async () => {
      const resstate = await fetch(
        api_path +
          `/COST_SF_NONTP_ORIGIN.php?parDateFrom=${getDateFrom}&parDateTo=${getDateTo}`
      );
      const getst = resstate.json();
      setOriginList(await getst);
    };
    getOriginDropdown().then();
    //}else{
    //}
  }, [getDateFrom, getDateTo]);
  useEffect(() => {
    //if(props.USER_COUNTRY=="TH"){
    const getDeliveryDropdown = async () => {
      const resstate = await fetch(
        api_path +
          `/COST_SF_NONTP_DEL.php?parDateFrom=${getDateFrom}&parDateTo=${getDateTo}&parOrigin=${selectOrigin}`
      );
      const getst = resstate.json();
      setDeliveryList(await getst);
    };
    getDeliveryDropdown().then();
    //}
  }, [selectOrigin]);
  const handleOriginChange = (obj) => {
    if (obj !== null) {
      setDateStr("Please click Search button to refresh data.");
      setSearchStatus(0);
      setSelectOrigin(obj.ORIGIN);
      setOrigin({
        ORIGIN: obj.ORIGIN,
        ORIGIN: obj.ORIGIN,
      });
    } else {
      setOrigin(null);
    }
  };
  const handleDeliveryChange = (obj) => {
    setDateStr("Please click Search button to refresh data.");
    setSearchStatus(0);
    setSelectDelivery(
      Array.isArray(obj) ? obj.map((x) => x.value).join("|") : []
    );
    setDelivery({
      value: obj.DELIVERY,
      label: obj.DELIVERY,
    });
  };
  const fetchType = () => {
    axios
      .get(api_path + `/COST_SF_NONTP_TYPE.php`)
      .then((response) => {
        setTypeList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleTypeChange = (obj) => {
    if (obj !== null) {
      setDateStr("Please click Search button to refresh data.");
      setSearchStatus(0);
      setSelectType(obj.getType);
      setType({
        getType: obj.getType,
        getType: obj.getType,
      });
    } else {
      setType([]);
      setSelectType([]);
    }
  };
  const fetchServiceType = () => {
    axios
      .get(api_path + `/COST_SF_NONTP_SERVICE_TYPE.php`)
      .then((response) => {
        setServiceTypeList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleServiceTypeChange = (obj) => {
    if (obj !== null) {
      setDateStr("Please click Search button to refresh data.");
      setSearchStatus(0);
      setSelectServiceType(obj.SERVICE_TYPE);
      setServiceType({
        SERVICE_TYPE: obj.SERVICE_TYPE,
        SERVICE_TYPE: obj.SERVICE_TYPE,
      });
    } else {
      setServiceType([]);
      setSelectServiceType([]);
    }
  };

  const url =
    api_path +
    "/COSTSHEET.php?origin=" +
    selectOrigin +
    "&delivery=" +
    GET_DEL +
    "&type=" +
    selectType +
    "&servicetype=" +
    selectServiceType +
    "&DateFrom=" +
    getDateFrom +
    "&DateTo=" +
    getDateTo +
    "&search=" +
    getSearchStatus +
    "&load=" +
    getLoadGrid;
  const dataSource = createStore({
    key: "COSTID",
    loadUrl: url,
    reshapeOnPush: true,
    onBeforeSend(method, ajaxOptions) {
      ajaxOptions.crossDomain = true;
      ajaxOptions.xhrFields = { withCredentials: true };
      ajaxOptions.headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
    },
  });
  const columnChooserModes = [
    {
      key: "dragAndDrop",
      name: "Drag and drop",
    },
    {
      key: "select",
      name: "Select",
    },
  ];
  const searchEditorOptions = { placeholder: "Search column" };
  const columnChooserModeLabel = { "aria-label": "Column Chooser Mode" };
  const cellPrepared = (e) => {
    setTotalCount(e.component.totalCount());
    if (e.rowType === "data") {
      if (e.column.dataField === "VALID" && e.data.VALID === "Valid") {
        e.cellElement.style.cssText = "color: #9ACD32;font-weight:bold;";
      } else if (e.column.dataField === "VALID" && e.data.VALID === "Invalid") {
        e.cellElement.style.cssText = "color: #ff6f4a;font-weight:bold;";
      }

      // if (e.column.dataField === "LOG_STATUS" && e.data.LOG_STATUS == "1") {
      // }
      if (e.data.LOG_STATUS == "1") {
        // e.cellElement.style.cssText = "color:red;font-weight:bold;";
        e.cellElement.style.color = "red";
        e.cellElement.style.fontWeight = "bold";
        //e.cellElement.style.backgroundColor = "#ff6f4a";
      }
    }
  };
  const rowPrepared = (e) => {
    if (e.rowType === "data") {
      ///  if (e.data.LOG_STATUS == "1") {
      //     e.cellElement.style.cssText = "color: white; background-color: ff6f4a";
      // or
      ///e.rowElement.classList.add("my-class");
      // To override alternation color
      //e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
      // }
    }
  };
  const onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "CostSheet.xlsx"
        );
      });
    });
  };
  //Column Chooser
  const [mode, setMode] = React.useState(columnChooserModes[1].key);
  const [searchEnabled, setSearchEnabled] = React.useState(true);
  const [allowSelectAll, setAllowSelectAll] = React.useState(true);
  const [selectByClick, setSelectByClick] = React.useState(true);
  const [recursive, setRecursive] = React.useState(true);
  const isDragMode = mode === columnChooserModes[0].key;
  const onModeValueChanged = React.useCallback((e) => {
    setMode(e.value);
  }, []);
  const onSearchEnabledValueChanged = React.useCallback((e) => {
    setSearchEnabled(e.value);
  }, []);
  const onAllowSelectAllValueChanged = React.useCallback((e) => {
    setAllowSelectAll(e.value);
  }, []);
  const onSelectByClickValueChanged = React.useCallback((e) => {
    setSelectByClick(e.value);
  }, []);
  const onRecursiveValueChanged = React.useCallback((e) => {
    setRecursive(e.value);
  }, []);
  //end column chooser

  const numberFormat = (value) =>
    new Intl.NumberFormat("en-IN", {
      // style: "currency",
      // currency: "USD",
    }).format(value);
  const [modeSize, setModeSize] = useState("widget");
  function onEditButtonClick(e) {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    SET_COST_ID(e.row.key);
    setShow(true);
  }
  function onViewCommentButtonClick(e) {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    SET_COST_ID(e.row.key);
    setShowComment(true);
    fetchCommentData(e.row.key);
  }
  const showCommentData = true;
  const fetchCommentData = async (COST_ID) => {
    try {
      const response = await fetch(
        api_path + "/GET_COSTSHEET_LOG.php?COST_ID=" + COST_ID,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      setCommentData(data);
    } catch (error) {
      console.error("Error fetching comment data:", error);
    }
  };

  function DisplayCommentData(props) {
    // if (props.commentData.length > 0) {
    return (
      <table class="table table-Default table-hover">
        {showCommentData ? (
          <>
            {commentData.map((fdata) => {
              return (
                <tbody>
                  <tr>
                    {" "}
                    <td>{fdata.REMARK}</td>
                  </tr>
                  <tr>
                    <td>
                      <i class="dx-icon-user custom-icon-style"></i>&nbsp;
                      {fdata.USER_FIRSTNAME}&nbsp;&nbsp;
                      <br /> <i class="dx-icon-event custom-icon-style"></i>{" "}
                      {dateFormat(fdata.INSERT_DATE, "dd-mmm-yyyy h:MM:ss TT")}
                    </td>
                  </tr>
                </tbody>
              );
            })}
          </>
        ) : (
          <p>You cannot see the data</p>
        )}
      </table>
    );
    // } else {
    // }
  }
  const [errors, setErrors] = useState({});
  const validateForm = () => {
    const errors = {};
    if (REMARK.trim()) {
      if (!REMARK) {
        errors.remark = "Remark is required";
      }
    }
    return errors;
  };
  const isLog = (status) =>
    status && ["1"].indexOf(status.trim().toUpperCase()) >= 0;
  const isCommentVisible = (e) => !isLog(e.row.data.LOG_STATUS);

  const isViewVisible = (e) => isLog(e.row.data.LOG_STATUS);
  function updateComment(COST_ID, REMARK, userId) {
    const newErrors = validateForm();
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      alert("Invalid");
    } else {
      var data = {
        COST_ID: GET_COST_ID,
        LOG_STATUS: 1,
        REMARK: REMARK,
        CRM_UID: userId,
      };
      console.log("Payload to PHP:", data); // ดู JSON ที่จะส่ง
      fetch(api_path + "/COSTSHEET.php", {
        method: "POST",
        headers: {
          Accept: "application/form-data",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          if (result["status"] == "200") {
            swal("Done.", "Save data successfully.", "success", {
              buttons: true,
              timer: 5000,
            }).then(function () {
              handleClose();
              setLoadGrid(randomNumberInRange(1, 20));
            });
          } else {
            swal("Sorry", result["message"], "error", {
              buttons: true,
              timer: 5000,
            });
          }
        });
    }
  }
  return (
    <Container maxWidth="xl">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Modal
            className="modal"
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
          >
            <Modal.Header closeButton>
              <Modal.Title>Report price incorrect</Modal.Title>
              <Button1 variant="secondary" onClick={handleClose}>
                Close
              </Button1>
            </Modal.Header>
            <Modal.Body>
              <Grid container>
                <br />
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    updateComment(GET_COST_ID, REMARK, userId);
                  }}
                  id="editmodal"
                  className=""
                >
                  <input
                    type="hidden"
                    value={GET_COST_ID}
                    onChange={(e) => SET_COST_ID(e.target.value)}
                  />

                  <label>Please provide details of the error.</label>
                  <br />
                  <textarea
                    id="txtArea"
                    rows="3"
                    cols="70"
                    value={REMARK}
                    onChange={(e) => SET_REMARK(e.target.value)}
                    inputProps={{ maxLength: 250 }}
                  ></textarea>
                  {errors.remark && (
                    <span className="error-message">{errors.remark}</span>
                  )}
                </form>
              </Grid>
            </Modal.Body>
            <Modal.Footer>
              <button className="btn btn-secondary" onClick={handleClose}>
                Cancel
              </button>
              <button className="btn btn-primary" form="editmodal">
                Save
              </button>
            </Modal.Footer>
          </Modal>

          <Modal
            className="modal"
            show={showComment}
            onHide={handleCloseComment}
            backdrop="static"
            keyboard={false}
            size="lg"
          >
            <Modal.Header closeButton>
              <Modal.Title>Report price incorrect</Modal.Title>
              <Button1 variant="secondary" onClick={handleCloseComment}>
                Close
              </Button1>
            </Modal.Header>
            <Modal.Body>
              <Grid container>
                <br />
                <DisplayCommentData commentData={commentData} />
              </Grid>
            </Modal.Body>
            <Modal.Footer>
              <button
                className="btn btn-secondary"
                onClick={handleCloseComment}
              >
                Close
              </button>
            </Modal.Footer>
          </Modal>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <label className="head">Sea Freight Costsheet</label>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={2}>
          <label>Effective From</label>
          <span className="red">*</span>
          <DateBox
            styles={{
              menu: (provided) => ({ ...provided, zIndex: 9999 }),
            }}
            defaultValue={now}
            inputAttr={dateLabel}
            type="date"
            displayFormat="dd/MM/yyyy"
            value={getDateFrom}
            onValueChanged={onValueChangedDateFrom}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>To</label>
          <span className="red">*</span>

          <DateBox
            defaultValue={now}
            inputAttr={dateLabel}
            type="date"
            displayFormat="dd/MM/yyyy"
            value={getDateTo}
            min={getMinDate}
            // disabledDates={disableDates}
            onValueChanged={onValueChangedDateTo}
          />
        </Grid>
        <Grid item xs={12} sm={1}>
          <label>Origin</label>
          <Select
            className="react-select-container"
            ref={ref}
            placeholder="Select..."
            value={origin}
            options={originList}
            onChange={handleOriginChange}
            getOptionLabel={(x) => x.ORIGIN}
            getOptionValue={(x) => x.ORIGIN}
            // isClearable
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Del</label>
          <TextField
            size="small"
            name="GET_DEL"
            variant="outlined"
            fullWidth
            id="GET_DEL"
            value={GET_DEL}
            onChange={(e) => SET_DEL(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={1}>
          <label>Type</label>
          <Select
            styles={{
              menu: (provided) => ({ ...provided, zIndex: 998 }),
            }}
            ref={ref}
            placeholder="Select..."
            value={getType}
            options={typeList}
            onChange={handleTypeChange}
            getOptionLabel={(x) => x.getType}
            getOptionValue={(x) => x.getType}
            isClearable
            style={{ fontSize: "12px" }}
          />
        </Grid>
        <Grid item xs={12} sm={1}>
          <label>Service</label>
          <Select
            styles={{
              menu: (provided) => ({ ...provided, zIndex: 997 }),
            }}
            placeholder="Select..."
            value={getServiceType}
            options={ServiceTypeList}
            onChange={handleServiceTypeChange}
            getOptionLabel={(x) => x.SERVICE_TYPE}
            getOptionValue={(x) => x.SERVICE_TYPE}
            isClearable
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <div className="paddingSearchButton">&nbsp;</div>
          <Button1
            className="searchButton"
            type="button"
            variant="contained"
            color="primary"
            onClick={handleSearch}
          >
            Search
          </Button1>
          &nbsp;&nbsp;&nbsp;
          <Button1
            className="searchButton"
            type="button"
            variant="outlined"
            color="primary"
            onClick={handleClearInputClick}
          >
            Clear Filter
          </Button1>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <div className="labelResult">
            {getTotalCount > 0 && (
              <div style={{ marginTop: 0, lineHeight: "25px" }}>
                <div>
                  {" "}
                  Found cost: {numberFormat(getTotalCount)} items&nbsp;
                </div>
              </div>
            )}
            {getDateStr}
          </div>
        </Grid>
      </Grid>

      <Grid container className={classes.root}>
        <DataGrid
          onCellPrepared={cellPrepared}
          //onRowPrepared={rowPrepared}
          dataSource={dataSource}
          showBorders={true}
          columnAutoWidth={true}
          rowAlternationEnabled={false}
          allowColumnReordering={true}
          allowColumnResizing={true}
          columnResizingMode={modeSize}
          columnMinWidth={50}
          showScrollbar={true}
          keyExpr="COSTID"
          onExporting={onExporting}
          width="100%"
          onContentReady={onContentReady}
          height={height}
          repaintChangesOnly={true}
        >
          <Scrolling
            rowRenderingMode="virtual"
            showScrollbar="always"
            useNative="false"
            scrollByThumb="true"
          ></Scrolling>
          <MasterDetail enabled={true} component={CostSheetMasterDetailView} />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible={true} />
          <Selection mode="single" />
          <SearchPanel
            visible={true}
            width={240}
            placeholder="Full Text Search..."
          />

          <Column
            dataField="EFFECTIVE_DATE"
            caption="EFFECTIVE"
            dataType="date"
            format="dd-MMM-yyyy"
            allowHiding={false}
            width={100}
          />
          <Column
            dataField="EXPIRED_DATE"
            caption="EXPIRED"
            dataType="date"
            format="dd-MMM-yyyy"
            allowHiding={false}
            width={100}
          />

          <Column dataField="ORIGIN" allowHiding={false} />
          <Column dataField="CARRIER" caption="CARRIER" allowHiding={false} />
          <Column dataField="POR" />
          <Column dataField="POL" />
          <Column dataField="TRADE" allowHiding={false} />
          <Column dataField="POD" />
          <Column dataField="DELIVERY" caption="DEL" />
          <Column dataField="DISPLAY_DELIVERY" caption="DEL (ISO-CODE)" />
          
          <Column dataField="T20" caption="20'" dataType="number">
            <Format type="fixedPoint" precision={0} />
          </Column>
          <Column dataField="T40" caption="40'" dataType="number">
            <Format type="fixedPoint" precision={0} />
          </Column>

          <Column dataField="T40H" caption="40'HC" dataType="number">
            <Format type="fixedPoint" precision={0} />
          </Column>
          <Column dataField="T45" caption="45'" dataType="number">
            <Format type="fixedPoint" precision={0} />
          </Column>
          <Column dataField="TYPE" caption="TYPE" />
          <Column dataField="SC" caption="SC" width={100} />
          <Column dataField="COMMODITY" caption="COMMODITY" width={100} />
          <Column dataField="SERVICE_TYPE" caption="SERVICE" width={70} />
          <Column dataField="SHIPPINGFEE" caption="SHIPPING FEE" width={70} />
          <Column dataField="REMARK" visible={false} />
          <Column dataField="CONDITION" visible={false} />
          <Column
            dataField="DG_CONDITION"
            caption="DG CONDITION"
            visible={false}
          />
          <Column dataField="LOG_STATUS" visible={false} />
          <Column dataField="CREATE_BY" visible={false} />
          <Column dataField="CREATE_DATE" visible={false} />
          <Column type="buttons" caption="REPORT" alignment="center">
            <Button
              icon="comment"
              onClick={onEditButtonClick}
              hint="Click to report price incorrect"
              visible={isCommentVisible}
            />
            <Button
              icon="warning"
              onClick={onViewCommentButtonClick}
              hint="View details"
              visible={isViewVisible}
            />
          </Column>
          <ColumnChooser enabled={true} mode={mode}>
            <Position
              my="right top"
              at="right bottom"
              of=".dx-datagrid-column-chooser-button"
            />
            <ColumnChooserSearch
              enabled={searchEnabled}
              editorOptions={searchEditorOptions}
            />
            <ColumnChooserSelection
              allowSelectAll={allowSelectAll}
              selectByClick={selectByClick}
              recursive={recursive}
            />
          </ColumnChooser>
          <LoadPanel enabled={true} />
          <Export enabled={true} allowExportSelectedData={true} />
          <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
          <Paging defaultPageSize={25} />
        </DataGrid>
      </Grid>
    </Container>
  );
}
